<template>
    <div :class="`formulate-input-element formulate-input-element--${context.type}`"
         :data-type="context.type"
    >
        <div class="field">
            <div class="level is-mobile">
                <div class="level-left">
                    <label class="label level-item" for="password">Password</label>
                </div>
                <div class="level-right">
                    <button v-if="!disabled" class="button is-small is-text hide-password level-item" type="button" @click="togglePasswordVisibility">
                        {{ showPassword ? 'hide' : 'show' }}
                    </button>
                </div>
            </div>
            <div class="password-input-container">
                <svg class="password-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                        fill="currentColor"/>
                </svg>
                <input
                    class="password-input"
                    :type="showPassword ? '' : 'password'"
                    id="create_account_password"
                    name="create_account_password"
                    v-model="password"
                    :disabled="disabled"
                    :placeholder="disabled ? '************' : ''"
                    @input="validatePassword"
                >
            </div>

        </div>
        <div class="password-requirements">
            <div v-for="(text, key) in requirements" :key="key" class="requirement" :data-requirement="key">
        <span class="icon">
          <svg v-if="disabled || requirementsMet[key]" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-success">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M0 8C0 3.57583 3.57583 0 8 0C12.4242 0 16 3.57583 16 8C16 12.4242 12.4242 16 8 16C3.57583 16 0 12.4242 0 8ZM6.61736 11.2814C6.8017 11.2814 6.98604 11.208 7.13366 11.0604L11.8711 6.34085C12.1476 6.06434 12.1476 5.58477 11.8711 5.29025C11.5766 4.99501 11.1158 4.99501 10.8205 5.29025L6.61739 9.4934L4.81071 7.68671C4.51621 7.39147 4.05536 7.39147 3.76012 7.68671C3.46488 7.98122 3.46488 8.44207 3.76012 8.73731L6.10106 11.0604C6.22995 11.208 6.43302 11.2814 6.61736 11.2814Z"
                  fill="#82B541"/>
          </svg>
          <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-error">
            <path
                d="M8 0C3.58754 0 0 3.58754 0 8C0 12.4125 3.58754 16 8 16C12.4125 16 16 12.4125 16 8C16 3.58754 12.4125 0 8 0ZM11.0651 9.76842C11.419 10.1224 11.419 10.7118 11.0651 11.0651C10.8796 11.2507 10.6612 11.3349 10.425 11.3349C10.1894 11.3349 9.95325 11.2507 9.78483 11.0651L7.9999 9.29671L6.23148 11.0651C6.04595 11.2507 5.82754 11.3349 5.59134 11.3349C5.35582 11.3349 5.11963 11.2507 4.95121 11.0651C4.59726 10.7112 4.59726 10.1217 4.95121 9.76842L6.70312 8L4.9347 6.23158C4.58075 5.87763 4.58075 5.28815 4.9347 4.93487C5.28866 4.58092 5.87813 4.58092 6.23141 4.93487L7.99983 6.70329L9.76825 4.93487C10.1222 4.58092 10.7117 4.58092 11.065 4.93487C11.4189 5.28883 11.4189 5.8783 11.065 6.23158L9.29654 8L11.0651 9.76842Z"
                fill="#B54141"/>
          </svg>
        </span>
                <span>{{ text }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PasswordInput',
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        initialPassword: {
            type: String,
            default: ''
        },
        context: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            password: this.context.model ? this.context.model : null,
            showPassword: false,
            requirements: {
                lowercase: 'One lowercase character',
                uppercase: 'One uppercase character',
                number: 'One number',
                special: 'One special character',
                length: '8 characters minimum',
            },
            requirementsMet: {
                lowercase: false,
                uppercase: false,
                number: false,
                special: false,
                length: false,
            }
        }
    },
    computed: {
        model() {
            return this.context.model
        }
    },
    methods: {
        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },
        validatePassword() {
            const rules = {
                lowercase: /[a-z]/,
                uppercase: /[A-Z]/,
                number: /[0-9]/,
                special: /[!@#$%^&*(),.?":{}|<>]/,
                length: /.{8,}/,
            };

            Object.keys(this.requirements).forEach(key => {
                this.requirementsMet[key] = rules[key].test(this.password);
            });

            this.$emit('input', this.password);
            this.context.model = this.password
        }
    },
    mounted() {
        if(this.password){
            this.validatePassword();
        }
    }
}
</script>

<style scoped>
.password-input-container {
  position: relative;
}

.password-icon {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #888;
}
.password-input{
   padding: 15px 20px 15px 40px;
}

.password-requirements {
    margin-top: 1rem;
}

.requirement {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
}

.requirement .icon {
    margin-right: 0.5rem;
    width: 16px;
    height: 16px;
}
</style>
